// Create a context
import React, { createContext, useContext, useState, ReactNode } from "react";

type GlobalStateContextType = {
  LogInUserName: string;
  setLogInUserName: Function;
  LogInUserImage: string;
  setLogInUserImage: Function;
  LogInUserRole: string;
  setLogInUserRole: Function;
  ManageAdmin: boolean;
  setManageAdmin: Function;
  NotificationObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
  };
  setNotificationObject: Function;

  ImagePreviewObject: {
    ShowPopup: boolean;
    ImageURL: string;
  };
  setImagePreviewObject: Function;

  ConfirmationModalObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
    ID: number;
    SelectedID: number;
    OtherID: number;
    Object: any;
  };
  setConfirmationModalObject: Function;

  RefreshGlobalTimer: boolean;
  setRefreshGlobalTimer: Function;

  WhiteTheme: boolean;
  SetWhiteTheme: Function;

  ShowAnimation: boolean;
  setShowAnimation: Function;

  SomeTaskIsRunning: boolean;
  setSomeTaskIsRunning: Function;

  MySelectedWorkspaceObject: {
    Code: any;
    DBIdentifier: any;
    Description: any;
    MGWorkspaceID: any;
    Selected: any;
    Title: any;
  };
  SetMySelectedWorkspaceObject: Function;

  showAddMGEventModal: boolean;
  setShowAddMGEventModal: Function;

  currentlySelectedEvent: any;
  setCurrentlySelectedEvent: Function;

  selectedEventID: any;
  setSelectedEventID: Function;

  newClassName: any;
  setNewClassName: Function;

  erdClassData: any;
  setErdClassData: Function;

  erdId: any;
  setErdId: Function;

  classes: any;
  setClasses: Function;

  typeSelection: any;
  setTypeSelection: Function;
};

const GlobalStateContext = createContext<GlobalStateContextType | undefined>(
  undefined
);

export const GlobalStateProvider = ({ children }: any) => {
  const [LogInUserName, setLogInUserName] = useState<string>("");
  const [LogInUserImage, setLogInUserImage] = useState<string>("");
  const [LogInUserRole, setLogInUserRole] = useState<string>("");
  const [ManageAdmin, setManageAdmin] = useState<boolean>(false);
  const [RefreshGlobalTimer, setRefreshGlobalTimer] = useState<boolean>(false);
  const [WhiteTheme, SetWhiteTheme] = useState<boolean>(false);
  const [ShowAnimation, setShowAnimation] = useState<boolean>(false);
  const [SomeTaskIsRunning, setSomeTaskIsRunning] = useState<boolean>(false);
  const [showAddMGEventModal, setShowAddMGEventModal] =
    useState<boolean>(false);
  const [currentlySelectedEvent, setCurrentlySelectedEvent] = useState<any>({});
  const [selectedEventID, setSelectedEventID] = useState<any>(0);
  const [newClassName, setNewClassName] = useState<any>(0);
  const [typeSelection, setTypeSelection] = useState<any>([]);
  const [classes, setClasses] = useState<any[]>([]);
  const [erdId, setErdId] = useState<any>(0);
  const [erdClassData, setErdClassData] = useState([]);
  const [NotificationObject, setNotificationObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
  });
  const [ImagePreviewObject, setImagePreviewObject] = useState({
    ShowPopup: false,
    ImageURL: "",
  });

  const [ConfirmationModalObject, setConfirmationModalObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
    ID: 0,
    SelectedID: 0,
    OtherID: 0,
    Object: {},
  });
  const [MySelectedWorkspaceObject, SetMySelectedWorkspaceObject] = useState({
    Code: "",
    DBIdentifier: "",
    Description: "",
    MGWorkspaceID: 0,
    Selected: false,
    Title: "",
  });
  return (
    <GlobalStateContext.Provider
      value={{
        LogInUserName,
        setLogInUserName,
        LogInUserImage,
        setLogInUserImage,
        LogInUserRole,
        setLogInUserRole,
        ManageAdmin,
        setManageAdmin,
        NotificationObject,
        setNotificationObject,
        ImagePreviewObject,
        setImagePreviewObject,
        RefreshGlobalTimer,
        setRefreshGlobalTimer,
        ConfirmationModalObject,
        setConfirmationModalObject,
        MySelectedWorkspaceObject,
        SetMySelectedWorkspaceObject,
        WhiteTheme,
        SetWhiteTheme,
        ShowAnimation,
        setShowAnimation,
        SomeTaskIsRunning,
        setSomeTaskIsRunning,
        showAddMGEventModal,
        setShowAddMGEventModal,
        currentlySelectedEvent,
        setCurrentlySelectedEvent,
        selectedEventID,
        setSelectedEventID,
        newClassName,
        setNewClassName,
        erdClassData,
        setErdClassData,
        erdId,
        setErdId,
        classes,
        setClasses,
        typeSelection,
        setTypeSelection,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
